import React, { useState, useEffect } from 'react';
import NoMessage from '../components/NoMessage';
import NoSelect from '../components/NoSelect';
import MessageBox from '../components/MessageBox';
import MessageList from '../components/MessageList';

function Messages(props) {
    const [selectedMsg, setSelectedMgs] = useState(null);
    const [messages, setMessages] = useState([]);

    useEffect(() => {
        setMessages(props.messages);
        if (selectedMsg) {
            const updateSelectedMessage = props.messages.find((msg) => msg.id === selectedMsg.id);
            if (updateSelectedMessage) {
                setSelectedMgs(updateSelectedMessage);
            } else {
                setSelectedMgs(null);
            }
        }
    }, [props]);


    const renderContent = () => {
        if (messages.length === 0) return <NoMessage />;
        if (selectedMsg === null && props.pageType !== 'draft') return <NoSelect />;
        if (props.pageType === 'draft' && selectedMsg !== null) {
            const data = JSON.parse(selectedMsg.emailDetails);
            localStorage.setItem('recipient', data.recipient.join(','));
            localStorage.setItem('cc', data.cc.join(','));
            localStorage.setItem('bcc', data.bcc.join(','));
            localStorage.setItem('subject', data.subject);
            localStorage.setItem('message', data.message);
            return;
        }
        return <MessageBox message={selectedMsg} reRender={props.reRender} setSelectedMgs={setSelectedMgs} pageType={props.pageType} />;
    };

    return (
        <div className="row inbox-body-section">
            <MessageList messages={messages} setSelectedMgs={setSelectedMgs} reRender={props.reRender} selectedmessage={selectedMsg} pageType={props.pageType} />
            {renderContent()}
        </div>
    );
}

export default Messages;
